module.exports = __webpack_public_path__ + "img/bocas-del-toro.28ec6db7.jpg";